import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import authReducer from "./reducers/authReducer"
import infoSlice from "./reducers/infoSlice"
// import UploadSlice from "./reducers/generalKtrn"
// import UpdateStoks from "./reducers/updateStoks"
import ordersReducer from "./reducers/ordersReducer"
import updateStoksIconReducer from "./reducers/updateStoksIcon"
import updateStoksKatrenReducer from "./reducers/updateStoksKatren"
import settingsReducer from "./reducers/settingsReducer"
import updateStoksPodruzhkaReducer from "./reducers/updateStoksPodruzhka"
import updateStoksMetroReducer from "./reducers/updateStoksMetro"
import updateStocksSamsonReducer from "./reducers/updateStocksSamson"
import reportsSlice from "./reducers/reportsSlice"
import contentState from "./reducers/contentSlice"
import feedShopsState from "./reducers/feedShopsSlice"
import shopsState from "./reducers/shopsSlice"
import wbToken from "./reducers/wbTokenSlice"
import analytics from "./reducers/analyticsSlice"
// import WSocketService from "./reducers/webSocketReducer"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    info: infoSlice,
    // generalKtrn: UploadSlice,
    // updateStoksStore: UpdateStoks,
    ordersStore: ordersReducer,
    updateStoksIcon: updateStoksIconReducer,
    settings: settingsReducer,
    updateStoksKatren: updateStoksKatrenReducer,
    updateStoksPodruzhka: updateStoksPodruzhkaReducer,
    updateStoksMetro: updateStoksMetroReducer,
    updateStocksSamson: updateStocksSamsonReducer,
    reportState: reportsSlice,
    contentState,
    feedShopsState,
    shopsState,
    wbToken,
    analytics,
    // WSocketService: WSocketService,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
